import classNames from 'classnames/bind'
import React, { FC } from 'react'
import Banner from '../../../ui-4.0/components/Banner/Banner'
import Routes from '../../../utils/routes'
import { scrollRef } from '../../../utils/scroll'
import Footer from '../../Footer'
import styles from './ApplicationForm.module.scss'
const cx = classNames.bind(styles)


const KYCForm: FC = ({ children }) => {
	const path = window.location.pathname
	const category = path.includes(Routes.account.verify.address)
		? 'address_verification'
		: 'id_verification'
	return <div className={cx('application-form')}>
		<Banner category={category} />
		<div className={cx('main-content')}>
			<div className={cx('scrollable')} ref={scrollRef}>
				<div className={cx('content')}>
					<div>
						{children}
					</div>
				</div>
				<Footer />
			</div>
		</div>
	</div>
}


export default KYCForm
